var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createEvent, createEffect, guard, sample, forward } from "effector";
import { $playerCurrentTrack, $playerCurrentTrackIndex, $playerNextTrack, $playerPreviousTrack, setPlayerCurrentTrackIndex, setPlayerTrackQueue } from "frontend/src/domain/player-track-queue";
import { getTimetablePlaylistForToday } from "frontend/src/api/timetables";
import { play, resetAudio } from "frontend/src/features/control-audio";
import { state } from 'frontend/src/shared/state';
export var playCurrentTrackInQueueAttempted = createEvent();
export var tryPlayNextTrackInQueue = createEvent();
export var tryPlayPreviousTrackInQueue = createEvent();
export var tryPlayNextTrackInQueueManually = createEvent();
export var tryPlayPreviousTrackInQueueManually = createEvent();
export var reloadPlaylistForPrevNextInTimetable = createEffect(function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        if (state.currentTimetableId !== -1 && params > 0 && !state.timetableReloading && state.trackSwitchedByUser) {
            state.timetableReloading = true;
            resetAudio();
            setPlayerCurrentTrackIndex(0);
            getTimetablePlaylistForToday(state.currentTimetableId)
                .then(function (tracks) {
                setPlayerTrackQueue({
                    type: "today_timetable",
                    attributes: {
                        id: state.currentTimetableId,
                        title: state.currentTimetableTitle
                    },
                    tracks: tracks
                });
                setPlayerCurrentTrackIndex(0);
                play(tracks[0].url);
                state.timetableReloading = false;
                state.trackSwitchedByUser = false;
            }).catch(function () {
                state.timetableReloading = false;
                state.trackSwitchedByUser = false;
            });
        }
        return [2 /*return*/, {}];
    });
}); });
var playNextTrackInQueueAttempted = createEvent();
var playPreviousTrackInQueueAttempted = createEvent();
guard({
    clock: playCurrentTrackInQueueAttempted,
    source: $playerCurrentTrack.map(function (source) { return source === null || source === void 0 ? void 0 : source.url; }),
    filter: function (url) { return typeof url === 'string'; },
    target: play.prepend(function (url) { return url !== null && url !== void 0 ? url : ""; }),
});
guard({
    clock: tryPlayNextTrackInQueue,
    source: $playerNextTrack,
    filter: function (track) { return !!track; },
    target: playNextTrackInQueueAttempted,
});
guard({
    clock: tryPlayPreviousTrackInQueue,
    source: $playerPreviousTrack,
    filter: function (track) { return !!track; },
    target: playPreviousTrackInQueueAttempted,
});
var targetNextTrack = sample({
    clock: playNextTrackInQueueAttempted,
    source: $playerCurrentTrackIndex,
    fn: function (index) { return index + 1; },
    target: [setPlayerCurrentTrackIndex, playCurrentTrackInQueueAttempted],
});
var targetPrevTrack = sample({
    clock: playPreviousTrackInQueueAttempted,
    source: $playerCurrentTrackIndex,
    fn: function (index) { return index - 1; },
    target: [setPlayerCurrentTrackIndex, playCurrentTrackInQueueAttempted],
});
forward({
    from: targetNextTrack,
    to: reloadPlaylistForPrevNextInTimetable
});
